import { Dialog, Grid, Typography, Button } from "@mui/material";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
}: ConfirmDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ style: { overflow: "hidden" } }}
    >
      <Grid container spacing={2} style={{ padding: "1em" }}>
        {title && (
          <Grid item xs={12}>
            <Typography
              variant="h5"
              component="div"
              align="center"
              style={{ fontWeight: "bold", color: "#424141" }}
            >
              {title}
            </Typography>
          </Grid>
        )}

        <Grid item xs={12}>
          <Typography variant="h6" component="div" align="center">
            {message}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          className="starlink--base--flex starlink--base--mtb_07x starlink--base--flex--justify--end"
        >
          <Button
            variant="outlined"
            className="starlink--button--cancel"
            onClick={onClose}
          >
            {cancelLabel}
          </Button>
          <Button
            variant="contained"
            className="starlink--button_contained--primary"
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default ConfirmDialog;
